var _g, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgShoppingCart = function SvgShoppingCart(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 40,
    height: 40,
    fill: "none",
    "aria-label": "shopping-cart-icon",
    viewBox: "0 0 40 40"
  }, props), _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#a)"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "#fff",
    d: "M11.668 30c-1.833 0-3.317 1.5-3.317 3.333s1.484 3.333 3.317 3.333 3.333-1.5 3.333-3.333S13.501 30 11.668 30m-10-26.667v3.333h3.333l6 12.65-2.25 4.084a3.2 3.2 0 0 0-.416 1.6c0 1.833 1.5 3.333 3.333 3.333h20V25h-19.3a.413.413 0 0 1-.417-.417l.05-.2 1.5-2.717h12.417c1.25 0 2.35-.683 2.917-1.716L34.8 9.133c.134-.233.2-.517.2-.8 0-.917-.75-1.667-1.666-1.667H8.685L7.118 3.333zM28.335 30c-1.834 0-3.317 1.5-3.317 3.333s1.483 3.333 3.317 3.333c1.833 0 3.333-1.5 3.333-3.333S30.168 30 28.335 30"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "a"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "#fff",
    d: "M0 0h40v40H0z"
  })))));
};
export default SvgShoppingCart;